import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import config from "./config.json";

Sentry.init({
  dsn: "https://67276ab4fe4d4906931fa59859a49bc7@o4504791404445696.ingest.sentry.io/4504791420567552",
  integrations: [
    new BrowserTracing(),
    new Sentry.Integrations.Breadcrumbs({
      console: false,
    }),
    new Sentry.Replay(),
  ],

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  tracesSampler: () => (process.env.NODE_ENV === "production" ? 1 : 0.2),
});

const theme = createTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_PRIMARY_MAIN
        ? process.env.REACT_APP_PRIMARY_MAIN
        : config.palette.primary.main,
    },
    secondary: {
      main: process.env.REACT_APP_SECONDARY_MAIN
        ? process.env.REACT_APP_SECONDARY_MAIN
        : config.palette.secondary.main,
    },
    third: {
      main: process.env.REACT_APP_THIRD_MAIN
        ? process.env.REACT_APP_THIRD_MAIN
        : config.palette.third.main,
    },
    darkbackground: {
      main: process.env.REACT_APP_DARKBACKGROUND_MAIN
        ? process.env.REACT_APP_DARKBACKGROUND_MAIN
        : config.palette.darkbackground.main,
      contrastText: process.env.REACT_APP_DARKBACKGROUND_CONTRAST_TEXT
        ? process.env.REACT_APP_DARKBACKGROUND_CONTRAST_TEXT
        : config.palette.darkbackground.contrastText,
      secondary: process.env.REACT_APP_DARKBACKGROUND_SECONDARY
        ? process.env.REACT_APP_DARKBACKGROUND_SECONDARY
        : config.palette.darkbackground.secondary,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
